import _forEach from 'lodash/forEach';
import templateCompiler from './template-compiler';

const lodash = { _forEach };

const html = `
<div class="option option-<%= option.handle %> is-select">
  <label class="option-label"><%= option.title %></label>
  <select class="option-values" data-option-bind="<%= option.id %>">
    <% _forEach(option.values, function (value){ %>
      <option
        data-value-position="<%= value.position %>"
        value="<%= value.position %>"
        <% if (option.selected == value.position & initOption) { %>selected<% } %>
      >
        <%= value.title %>
      </option>
    <% }) %>
  </select>
</div>`;

export default templateCompiler(html, lodash);
